export { default } from './BancoAutoCarroDesktop';
